import React from "react";
import logo from "../Asset/logo.png";
import down from "../Asset/down.svg"
import profile from "../Asset/user_pic.png";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { IoIosMenu } from "react-icons/io";
import AuthService from "../Authentication/AuthService";
import {
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import "antd/dist/antd.css";
import { Menu, Button } from "antd";
import Role from "../helpers/role";
const { SubMenu } = Menu;

class MMTopPane extends React.Component {
  authService;
  constructor() {
    super();
    this.authService = new AuthService();
    this.state = {
      show: false,
      currentUser: "",
      isMobile: false,
      isMobileWeb: false,
      isMobileWebSmall: false,
      isMobile600: false,
      isMobile1430: false,
      isMobile500: false,
    };
  }

  componentDidMount() {
    window.addEventListener('resize', this.resize);
    this.resize();
    this.showTime();
    let user1 = localStorage.getItem("UserRoles");
    var _this = this;
    const { history } = this.props;
    _this.authService.getCurrentUserDetails().then(function (user) {
      _this.setState({ currentUser: user });
      _this.props.dispatch({ type: "UserRole", data: user1 });
      _this.props.dispatch({
        type: "AuthenticatedUserInformation",
        data: user,
      });
      if (user.role === "staff") {
        _this.props.dispatch({ type: "ShipRole", data: "Staff" });
      }
    });
    this.interval = setInterval(() => {
      this.showTime();
      // this.resize();
    }, 1000);
  }
  componentWillUnmount() {
    window.removeEventListener('resize', this.resize);
  };
  resize = () => {
    if (window.innerWidth <= 495) {
      this.setState({
        isMobileWebSmall: true,
      });
    } else {
      this.setState({
        isMobileWebSmall: false,
      });
    }
    if (window.innerWidth > 1500) {
      this.setState({
        isMobile: true,
      });
    } else {
      this.setState({
        isMobile: false,
      });
    }
    if (window.innerWidth <= 1120) {
      this.setState({
        isMobileWeb: true,
      });
    } else {
      this.setState({
        isMobileWeb: false,
      });
    }
    if (window.innerWidth <= 600) {
      this.setState({
        isMobile600: true
      });
    } else {
      this.setState({
        isMobile600: false
      });
    }
    if (window.innerWidth <= 1430) {
      this.setState({
        isMobile1430: true
      });
    } else {
      this.setState({
        isMobile1430: false
      });
    }
    if (window.innerWidth <= 500) {
      this.setState({
        isMobile500: true
      });
    } else {
      this.setState({
        isMobile500: false
      });
    }
  };
  showTime = () => {
    var today = new Date();
    let year = today.getFullYear();
    var monthNames = [
      "JAN",
      "FEB",
      "MAR",
      "APR",
      "MAY",
      "JUN",
      "JUL",
      "AUG",
      "SEP",
      "OCT",
      "NOV",
      "DEC"
    ];
    let month = monthNames[today.getMonth()];

    let date = today.getDate()
    var h = today.getUTCHours();
    var m = today.getUTCMinutes();
    var s = today.getUTCSeconds();
    if (h > 24) {
      h = h - 24;
    }
    if (h < 0) {
      h = h + 24;
    }
    h = this.checkTime(h);
    m = this.checkTime(m);
    s = this.checkTime(s);
    if (date < 10) date = '0' + date;
    var time = date + "-" + month + "-" + year + " " + h + ":" + m + ":" + s + "" + "UTC";
    if (document.getElementById("MyClockDisplay")) {
      document.getElementById("MyClockDisplay").innerText = time;
    }
    if (document.getElementById("MyClockDisplay")) {
      document.getElementById("MyClockDisplay").textContent = time;
    }
  }

  checkTime = (i) => {
    if (i < 10) {
      i = "0" + i
    };
    return i;
  }


  password = () => {
    this.props.history.push("/Home/ChangePassword");
    // this.props.history.push("/password");
    this.setState({ show: false });
    // this.authService.password();
  };

  render() {
    const { userDetail, equipmentInfo, history } = this.props;
    const { currentUser } = this.state;
    let userRole = localStorage.getItem("UserRoles");
    // Change to currentUser.role => user

    return (
      <div className="app-hheader">
        {/* <div className='collapse show label'>
                    <span>System </span>
                    <span>|  </span>
                    <span>Account</span>
                </div> */}
        <div className="site-hheader-inner">
          {/* <div
          className="row wid100 ml-0 "
          style={{ maxWidth: "100%", flex: "0 0 100%" }}
        >
          <div className="col-sm4 col-3 p0 m-0">
            <a
              href="#"
              style={{ margin: "0rem 0rem 0rem 0rem" }}
              className="logo-outer mmpl_logo"
              onClick={() => {
                history.push("/");
              }}
            >
              <img className="logo-imagenav" src={logo} style={{width:"160px",marginTop:"2px"}}></img>
            </a>
            <span class="ihmmainten">Alcovisor</span>
          </div>
        
          <div className="col-2 col-sm5 clockpadding">
        <div className="card ccard px-1 pt-2 h-100">
          <div id="MyClockDisplay" className="clock" onLoad={()=>this.showTime()}></div></div>
          </div>
        
          <div
            className={`${this.state.isMobile? "" : "m-auto"} col-sm2  padd`}
            data-toggle="collapse"
            data-target="#main_nav" >
            <IoIosMenu
              onClick={(e) => this.setState({ show: !this.state.show })}
              style={{ width: "40px", height: "40px", float: "right" }}
              className="do menu"
            />
          </div> 
            <nav className="navbar-expand-lg h-menu col-sm11 col-4 text-center py-2 titlepadding">
              <div className="h-menu navbar-collapse">
                <ul className="navbar-nav m-auto">
                  {userRole == Role.client || userRole == Role.clientuser || userRole == Role.consultant ? (
                    <li className="nav-item nav-menu-item">
                      <a
                        className="nav-link discover navstyle"
                        onClick={(e) => this.ShippingCompanyNavigation(e)}
                        href="/Home/CompanyDashboard"
                      >
                        Home
                      </a>
                    </li>
                  ) : null}
                  {userRole == Role.mmpl || userRole == Role.mmpladmin ? (
                    <li className="nav-item nav-menu-item">
                      <a
                        className="nav-link discover navstyle"
                        onClick={(e) => this.MMPLDashboardNavigation(e)}
                        href="/Home/MMPLDashboard"
                      >
                        Home
                      </a>
                    </li>
                  ) : null}

                  {userRole == Role.staff ? (
                    <li className="nav-item nav-menu-item">
                      <a
                        className="nav-link discover navstyle"
                        onClick={(e) => this.ShipViewNavigation(e)}
                        href="/Home/StaffDashboard"
                      >
                        Home
                      </a>
                    </li>
                  ) : null}

                  <li className="nav-item nav-menu-item">
                    <a
                      className="nav-link discover navstyle"
                      onClick={(e) => this.CrewVisitorSearchNavigation(e)}
                      href="/Home/Search"
                    >
                      Reports
                    </a>
                  </li>
                  {userRole == Role.mmpladmin ? (
                    <li className="nav-item nav-menu-item">
                      <a
                        className="nav-link discover navstyle"
                        onClick={(e) => this.SettingsMemberNavigation(e)}
                        href="/Home/ShippingSettings"
                      >
                        Settings
                      </a>
                    </li>
                  ) : null}

                  {userRole == Role.staff || userRole == Role.mmpl || userRole == Role.clientuser || userRole == Role.client || userRole == Role.consultant ? (
                    <li className="nav-item nav-menu-item">
                      <a
                        className="nav-link discover navstyle"
                        onClick={(e) => this.NewSearchNavigation(e)}
                        href="/Home/Management/Report">
                        Reports Management
                      </a>
                    </li>
                  ) : null}
                  {userRole == Role.staff ? (
                    <li className="nav-item nav-menu-item">
                      <a
                        className="nav-link discover navstyle"
                        onClick={(e) => this.StaffCrewMemberNavigation(e)}
                        href="/Home/CrewManagement">
                        Crew
                      </a>
                    </li>)
                    : null}
                  {userRole == Role.mmpladmin ? (
                    <li class="nav-item dropdown nav-menu-item">
                      <a
                        class="nav-link dropdown-toggle discover navstyle"
                        href="#"
                        id="navbarDropdownMenuLink"
                        data-toggle="dropdown"
                        aria-haspopup="true"
                        aria-expanded="false"
                      >
                        {" "}
                        Admin{" "}
                      </a>
                      <ul
                        class="dropdown-menu"
                        aria-labelledby="navbarDropdownMenuLink"
                      >
                        {userRole == Role.mmpladmin ? (
                          <li
                            onClick={(e) => this.ClientManagementNavigation(e)}
                          >
                            <a
                              class="dropdown-item"
                              href="/Home/Management/Client"
                            >
                              Client Management
                            </a>
                          </li>
                        ) : null}
                        {userRole == Role.mmpladmin ? (
                          <li onClick={(e) => this.ShipManagementNavigation(e)}>
                            <a
                              class="dropdown-item"
                              href="/Home/Management/Ship"
                            >
                              Ship Management
                            </a>
                          </li>
                        ) : null}
                        {userRole == Role.mmpladmin ? (
                          <li onClick={(e) => this.DeviceNavigation(e)}>
                            <a
                              class="dropdown-item"
                              href="/Home/Management/Device"
                            >
                              Device Management
                            </a>
                          </li>
                        ) : null}


                        {userRole == Role.mmpladmin ? (
                          <li onClick={(e) => this.RankNavigation(e)}>
                            <a
                              class="dropdown-item"
                              href="/Home/Management/Rank"
                            >
                              Rank Management
                            </a>
                          </li>
                        ) : null}
                        {userRole == Role.mmpladmin ? (
                          <li onClick={(e) => this.CrewMemberNavigation(e)}>
                            <a
                              class="dropdown-item"
                              href="/Home/Management/CrewManagement"
                            >
                              Crew Management
                            </a>
                          </li>
                        ) : null}
                        {userRole == Role.mmpladmin ? (
                          <li onClick={(e) => this.VisitorMemberNavigation(e)}>
                            <a
                              class="dropdown-item"
                              href="/Home/Management/VisitorManagement"
                            >
                              Visitor Management
                            </a>
                          </li>
                        ) : null}
                        {userRole == Role.mmpladmin ? (
                          <li onClick={(e) => this.DeviceCalibrationSearchNavigation(e)}>
                            <a
                              class="dropdown-item"
                              href="/Home/Management/DeviceCalibration"
                            >
                              Device Calibration Due
                            </a>
                          </li>
                        ) : null}
                        {/* {userRole == Role.mmpladmin   ? (
                          <li onClick={(e) => this.CrewSearchNavigation(e)}>
                            <a
                              class="dropdown-item"
                              href="/Home/Management/CrewSearch"
                            >
                              Crew Search
                            </a>
                          </li>
                        ) : null} *
                        {userRole == Role.mmpladmin   ? (
                          <li onClick={(e) => this.NewSearchNavigation(e)}>
                            <a
                              class="dropdown-item"
                              href="/Home/Management/Report"
                            >
                              Reports Management
                            </a>
                          </li>
                        ) : null}
                        {userRole == Role.mmpladmin ? (
                          <li onClick={(e) => this.UserNavigation(e)}>
                            <a
                              class="dropdown-item"
                              href="/Home/Management/User"
                            >
                              MMPL User Management
                            </a>
                          </li>
                        ) : null}

                        {/* {currentUser.role == Role.mmpladmin ? (
                          <li
                            onClick={(e) => this.StaffManagementNavigation(e)}
                          >
                            <a
                              class="dropdown-item"
                              href="/Home/Management/Staff"
                            >
                              Ship Staff Management
                            </a>
                          </li>
                        ) : null} *
                      </ul>
                    </li>
                  ) : null}
                </ul>
              </div>
            </nav>

            {userDetail ? (
              <div className="ng-star-inserted h-menu col-3 col-sm10 text-right py-2">
                <div className="mt-2">
                  <UncontrolledDropdown>
                    <DropdownToggle nav caret>
                      {this.UserAvatar(userDetail)}
                      <span className="navstyle">
                        {userDetail.name.split("@")[0]}
                      </span>
                    </DropdownToggle>
                    <DropdownMenu right>
                      <h5 className="dropdown-item-text mb-0">
                        {userDetail.name.split("@")[0]}
                      </h5>
                      <p className="dropdown-item-text text-muted mb-0">
                        {userDetail.email}
                      </p>
                      <DropdownItem divider />
                      <DropdownItem onClick={() => this.password()}>
                        Change Password
                      </DropdownItem>
                      <DropdownItem onClick={() => this.logout()}>
                        Sign Out
                      </DropdownItem>
                    </DropdownMenu>
                  </UncontrolledDropdown>
                </div>
              </div>
            ) : (
              ""
            )}
          </div> */}
          <div className="row">
            <div className={this.state.isMobileWebSmall ? "col-5 w-100 d-flex align-items-center" : this.state.isMobileWeb ? "col-7 w-100 d-flex align-items-center" : "col-4 w-100 d-flex align-items-center"}>
              <div className={this.state.isMobileWeb ? "ml-2" : "ml-3"}>
                <a
                  href="#"
                  // style={{ margin: "0rem 0rem 0rem 0rem" }}
                  className="logo-outer mmpl_logo"
                  onClick={() => {
                    history.push("/");
                  }}
                >
                  <img className="logo-image" src={logo} alt="Marine Mechanics" />
                </a>
                {this.state.isMobile600 == false && <span class="ihmmainten">Alcovisor</span>}</div>
            </div>
            <div className={this.state.isMobileWeb ? "" : "col-4 justify-content-center d-flex"}>
              <nav className="navbar-expand-lg h-menu text-center py-2 titlepadding">
                <div className="h-100 navbar-collapse">
                  <ul className="navbar-nav m-auto">
                    {userRole == Role.client || userRole == Role.clientuser || userRole == Role.consultant ? (
                      <li className="nav-item nav-menu-item">
                        <a
                          className={`${window.location.pathname == "/Home/CompanyDashboard" ? "active-nav" : ""} nav-link discover navstyle`}
                          onClick={(e) => this.ShippingCompanyNavigation(e)}
                          href="/Home/CompanyDashboard"
                        >
                          Home
                        </a>
                      </li>
                    ) : null}
                    {userRole == Role.mmpl || userRole == Role.mmpladmin ? (
                      <li className="nav-item nav-menu-item">
                        <a
                          className={`${window.location.pathname == "/Home/MMPLDashboard" ? "active-nav" : ""} nav-link discover navstyle`}
                          onClick={(e) => this.MMPLDashboardNavigation(e)}
                          href="/Home/MMPLDashboard"
                        >
                          Home
                        </a>
                      </li>
                    ) : null}

                    {userRole == Role.staff ? (
                      <li className="nav-item nav-menu-item">
                        <a
                          className={`${window.location.pathname == "/Home/StaffDashboard" ? "active-nav" : ""} nav-link discover navstyle`}
                          onClick={(e) => this.ShipViewNavigation(e)}
                          href="/Home/StaffDashboard"
                        >
                          Home
                        </a>
                      </li>
                    ) : null}

                    <li className="nav-item nav-menu-item">
                      <a
                        className={`${window.location.pathname == "/Home/Search" ? "active-nav" : ""}  nav-link discover navstyle`}
                        onClick={(e) => this.CrewVisitorSearchNavigation(e)}
                        href="/Home/Search"
                      >
                        Search
                      </a>
                    </li>
                    {userRole == Role.mmpladmin ? (
                      <li className="nav-item nav-menu-item">
                        <a
                          className={`${window.location.pathname == "/Home/Settings" ? "active-nav" : ""} nav-link discover navstyle`}
                          onClick={(e) => this.SettingsMemberNavigation(e)}
                          href="/Home/ShippingSettings"
                        >
                          Settings
                        </a>
                      </li>
                    ) : null}

                    {userRole == Role.staff ? (
                      <li className="nav-item nav-menu-item">
                        <a
                          className={`${window.location.pathname == "/Home/CrewManagement" ? "active-nav" : ""} nav-link discover navstyle`}
                          onClick={(e) => this.StaffCrewMemberNavigation(e)}
                          href="/Home/CrewManagement">
                          Crew
                        </a>
                      </li>)
                      : null}
                    {userRole == Role.staff ? (
                      <li class="nav-item dropdown nav-menu-item">
                        <a
                          class={`${window.location.pathname == "/Home/Management/Report" || window.location.pathname == "/Home/Management/MonthlyReport" || window.location.pathname == "/Home/Management/MonthlyReportComments" ? "active-nav" : ""} nav-link dropdown-toggle discover navstyle`}
                          href="#"
                          id="staffReportsDropdownMenuLink"
                          data-toggle="dropdown"
                          aria-haspopup="true"
                          aria-expanded="false"
                        >
                          Reports
                        </a>
                        <ul
                          class="dropdown-menu"
                          aria-labelledby="staffReportsDropdownMenuLink"
                        >
                          <li onClick={(e) => this.NewSearchNavigation(e)}>
                            <a
                              class="dropdown-item"
                              href="/Home/Management/Report"
                            >
                              Crew Test Reports
                            </a>
                          </li>
                          <li onClick={(e) => this.MonthlyReportNavigation(e)}>
                            <a
                              class="dropdown-item"
                              href="/Home/Management/MonthlyReport"
                            >
                              Monthly Reports
                            </a>
                          </li>
                          <li onClick={(e) => this.MonthlyReportCommentsNavigation(e)}>
                            <a
                              class="dropdown-item"
                              href="/Home/Management/MonthlyReportComments"
                            >
                              Monthly Compliance Reports
                            </a>
                          </li>
                        </ul>
                      </li>
                    ) : null}

                    {userRole == Role.mmpl || userRole == Role.clientuser || userRole == Role.client || userRole == Role.consultant ? (
                      <li className="nav-item nav-menu-item">
                        <a
                          className={`${window.location.pathname == "/Home/Management/Report" ? "active-nav" : ""} nav-link discover navstyle`}
                          onClick={(e) => this.NewSearchNavigation(e)}
                          href="/Home/Management/Report">
                          Reports
                        </a>
                      </li>
                    ) : null}
                    {userRole == Role.mmpladmin ? (
                      <li class="nav-item dropdown nav-menu-item">
                        <a
                          class={`${window.location.pathname?.includes("/Home/Management/") ? "active-nav" : ""} nav-link dropdown-toggle discover navstyle`}
                          // class={`${ ["/Home/Management/","/Home/Management/Client", "/Home/Management/Ship", "/Home/Management/Device", "/Home/Management/CrewManagement", "/Home/Management/VisitorManagement", "/Home/Management/DeviceCalibration", "/Home/Management/CrewSearch", "/Home/Management/Report", "/Home/Management/User"]?.includes(window.location.pathname)  ? "active-nav" : ""} nav-link dropdown-toggle discover navstyle`}
                          href="#"
                          id="navbarDropdownMenuLink"
                          data-toggle="dropdown"
                          aria-haspopup="true"
                          aria-expanded="false"
                        >
                          {" "}
                          Admin{" "}
                        </a>
                        <ul
                          class="dropdown-menu"
                          aria-labelledby="navbarDropdownMenuLink"
                        >
                          {userRole == Role.mmpladmin ? (
                            <li
                              onClick={(e) => this.ClientManagementNavigation(e)}
                            >
                              <a
                                class="dropdown-item"
                                href="/Home/Management/Client"
                              >
                                Client Management
                              </a>
                            </li>
                          ) : null}
                          {userRole == Role.mmpladmin ? (
                            <li onClick={(e) => this.ShipManagementNavigation(e)}>
                              <a
                                class="dropdown-item"
                                href="/Home/Management/Ship"
                              >
                                Ship Management
                              </a>
                            </li>
                          ) : null}
                          {userRole == Role.mmpladmin ? (
                            <li onClick={(e) => this.DeviceNavigation(e)}>
                              <a
                                class="dropdown-item"
                                href="/Home/Management/Device"
                              >
                                Device Management
                              </a>
                            </li>
                          ) : null}


                          {userRole == Role.mmpladmin ? (
                            <li onClick={(e) => this.RankNavigation(e)}>
                              <a
                                class="dropdown-item"
                                href="/Home/Management/Rank"
                              >
                                Rank Management
                              </a>
                            </li>
                          ) : null}
                          {userRole == Role.mmpladmin ? (
                            <li onClick={(e) => this.CrewMemberNavigation(e)}>
                              <a
                                class="dropdown-item"
                                href="/Home/Management/CrewManagement"
                              >
                                Crew Management
                              </a>
                            </li>
                          ) : null}
                          {userRole == Role.mmpladmin ? (
                            <li onClick={(e) => this.VisitorMemberNavigation(e)}>
                              <a
                                class="dropdown-item"
                                href="/Home/Management/VisitorManagement"
                              >
                                Visitor Management
                              </a>
                            </li>
                          ) : null}
                          {userRole == Role.mmpladmin ? (
                            <li onClick={(e) => this.DeviceCalibrationSearchNavigation(e)}>
                              <a
                                class="dropdown-item"
                                href="/Home/Management/DeviceCalibration"
                              >
                                Device Calibration Due
                              </a>
                            </li>
                          ) : null}
                          {userRole == Role.mmpladmin ? (
                            <li onClick={(e) => this.CrewSearchNavigation(e)}>
                              <a
                                class="dropdown-item"
                                href="/Home/Management/CrewSearch"
                              >
                                Crew Search
                              </a>
                            </li>
                          ) : null}
                          {userRole == Role.mmpladmin ? (
                            <li onClick={(e) => this.NewSearchNavigation(e)}>
                              <a
                                class="dropdown-item"
                                href="/Home/Management/Report"
                              >
                                Reports
                              </a>
                            </li>
                          ) : null}
                          {userRole == Role.mmpladmin ? (
                            <li onClick={(e) => this.MonthlyReportNavigation(e)}>
                              <a
                                class="dropdown-item"
                                href="/Home/Management/Report"
                              >
                                Monthly Reports
                              </a>
                            </li>
                          ) : null}
                          {userRole == Role.mmpladmin ? (
                            <li onClick={(e) => this.UserNavigation(e)}>
                              <a
                                class="dropdown-item"
                                href="/Home/Management/User"
                              >
                                MMPL User Management
                              </a>
                            </li>
                          ) : null}
                          {userRole == Role.mmpladmin ? (
                            <li onClick={(e) => this.SpecialAccessUserNavigation(e)}>
                              <a
                                class="dropdown-item"
                                href="/Home/Management/SpecialAccessUser"
                              >
                                Special Access User Management
                              </a>
                            </li>
                          ) : null}
                        </ul>
                      </li>
                    ) : null}
                  </ul>
                </div>
              </nav>
            </div>
            <div className={`${this.state.isMobileWebSmall ? "col-7" : this.state.isMobileWeb ? "col-5" : "col-4"}`}>
              <div className="row h-100">
                {this.state.isMobile500 == false &&
                  <div className="col-7 clockpadding">
                    <div className="card ccard-color ccard-width px-1 h-100">
                      <div id="MyClockDisplay" className="clock" onLoad={() => this.showTime()}></div></div>
                  </div>}
                {userDetail ? (<>
                  <div className={this.state.isMobileWeb ? "h-menu" : `col-5 ng-star-inserted h-menu text-right d-flex justify-content-center  signout-border ${this.state.isMobile1430 ? ' align-items-center' : ' py-2'}`}>
                    <div className="dropdown-end">
                      <UncontrolledDropdown>
                        <DropdownToggle nav caret className="nav-user-page">
                          {this.state.isMobile1430 == false && <>{this.UserAvatar(userDetail)}</>}
                          <div className={`navstyle pl-2  navstyle-nowrap ${this.state.isMobile1430 ? '' : "pt-1 mt-1"}`}>
                            {userDetail.name.split("@")[0]}
                          </div>
                          <img className={this.state.isMobile1430 ? "down-icon1 " : "down-icon"}  style={{width:"14px"}} src={down}></img>
                        </DropdownToggle>
                        <DropdownMenu right>
                          <h5 className="dropdown-item-text mb-0">
                            {userDetail.name.split("@")[0]}
                          </h5>
                          <p className="dropdown-item-text text-muted mb-0">
                            {userDetail.email}
                          </p>
                          <DropdownItem divider />
                          <DropdownItem onClick={() => this.password()}>
                            Change Password
                          </DropdownItem>
                          <DropdownItem onClick={() => this.logout()}>
                            Sign Out
                          </DropdownItem>
                        </DropdownMenu>
                      </UncontrolledDropdown>
                    </div>
                  </div>
                  {/* {this.state.isMobile == true && */}
                  <div
                    className={`${this.state.isMobile500 ? "col-11" : this.state.isMobile ? "col-3" : "col-4"} ${this.state.isMobile ? "" : "m-auto"}   padd`}
                    data-toggle="collapse"
                    data-target="#main_nav" >
                    <IoIosMenu
                      onClick={(e) => this.setState({ show: !this.state.show })}
                      style={{ width: "40px", height: "40px", float: "right" }}
                      className="do menu"
                    />
                  </div>
                  {/* } */}
                </>) : (
                  ""
                )}
              </div>
            </div>
          </div>
        </div>
        {this.state.show ? (
          <div
            className="collapse  navbar-collapse show menu-item" id="main_nav">
            <Menu
              onClick={this.handleClick}
              style={{ width: "100%", borderRight: "none" }}
              defaultSelectedKeys={["1"]}
              // defaultOpenKeys={['sub1']}
              mode="inline"
            >
              <ul className="navbar-nav m-auto">
                {userRole == Role.client || userRole == Role.clientuser || userRole == Role.consultant ? (
                  <li className="nav-item nav-menu-item">
                    {/* <a className="nav-link discover navstyle" onClick={this.ClientDashboardNavigation} href="#" >
                                            Home
                                            </a> */}
                    <Menu.Item
                      key="M1"
                      className="navstyle space mobile-menu mobile-menu"
                      onClick={this.ShippingCompanyNavigation}
                    >
                      Home
                    </Menu.Item>
                  </li>
                ) : null}

                {userRole == Role.mmpl || userRole == Role.mmpladmin ? (
                  <li className="nav-item nav-menu-item">
                    {/* <a className="nav-link discover navstyle" onClick={this.MMPLDashboardNavigation} href="#">
                                            Home
                                            </a> */}
                    <Menu.Item
                      key="M1"
                      className="navstyle space mobile-menu"
                      onClick={this.MMPLDashboardNavigation}>
                      Home
                    </Menu.Item>
                  </li>
                ) : null}


                {userRole == Role.staff ? (
                  <li className="nav-item nav-menu-item">

                    <Menu.Item
                      key="M1"
                      className="navstyle space mobile-menu"
                      onClick={this.ShipViewNavigationMobile}
                    >
                      Home
                    </Menu.Item>
                  </li>
                ) : null}
                <li className="nav-item nav-menu-item">
                  <Menu.Item
                    key="M3"
                    className="navstyle space mobile-menu"
                    onClick={this.CrewVisitorSearchNavigation}>
                    Search
                  </Menu.Item>
                </li>
                {userRole == Role.mmpladmin ? (
                  <li className="nav-item nav-menu-item">
                    <Menu.Item
                      key="M2"
                      className="navstyle space mobile-menu"
                      onClick={this.SettingsMemberNavigationMobile}>
                      Settings
                    </Menu.Item>
                  </li>
                ) : null}
                {userRole == Role.mmpl || userRole == Role.clientuser || userRole == Role.client || userRole == Role.consultant ? (
                  <li className="nav-item nav-menu-item">
                    <Menu.Item
                      key="M2"
                      className="navstyle space mobile-menu"
                      onClick={this.NewSearchNavigation}>
                      Reports Management
                    </Menu.Item>
                  </li>
                ) : null}
                {userRole == Role.staff ? (
                  <li className="nav-item nav-menu-item">
                    <Menu.Item
                      key="M2"
                      className="navstyle space mobile-menu"
                      onClick={this.StaffCrewMemberNavigation}>
                      Crew
                    </Menu.Item>
                  </li>)
                  : null}
                {userRole == Role.staff ? (
                  <li class="nav-item dropdown nav-menu-item">
                    <a
                      class="nav-link dropdown-toggle discover navstyle1"
                      style={{ paddingLeft: "24px" }}
                      href="#"
                      id="staffReportsDropdownMenuLinkMobile"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                    >
                      {" "}
                      Reports{" "}
                    </a>
                    <ul
                      class="dropdown-menu"
                      aria-labelledby="staffReportsDropdownMenuLinkMobile"
                    >
                      <li>
                        <Menu.Item
                          key="M8S1"
                          className="navstyle space mobile-menu"
                          onClick={(e) => this.NewSearchNavigation(e)}
                        >
                          Crew Test Reports
                        </Menu.Item>
                      </li>
                      <li>
                        <Menu.Item
                          key="M8S2"
                          className="navstyle space mobile-menu"
                          onClick={(e) => this.MonthlyReportNavigation(e)}
                        >
                          Monthly Reports
                        </Menu.Item>
                      </li>
                      <li>
                        <Menu.Item
                          key="M8S3"
                          className="navstyle space mobile-menu"
                          onClick={this.MonthlyReportCommentsNavigation}
                        >
                          Monthly Compliance Reports
                        </Menu.Item>
                      </li>
                    </ul>
                  </li>
                ) : null}
                {userRole == Role.mmpladmin ? (
                  <li class="nav-item dropdown nav-menu-item">
                    <a
                      class="nav-link dropdown-toggle discover navstyle1"
                      style={{ paddingLeft: "24px" }}
                      href="#"
                      id="navbarDropdownMenuLink"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                    >
                      {" "}
                      Admin{" "}
                    </a>
                    <ul
                      class="dropdown-menu"
                      aria-labelledby="navbarDropdownMenuLink"
                    >
                      <li>
                        <Menu.Item
                          key="M5"
                          className="navstyle space mobile-menu"
                          onClick={(e) => this.ClientManagementNavigation(e)}
                        >
                          Client Management
                        </Menu.Item>
                      </li>
                      <li>
                        <Menu.Item
                          key="M3"
                          className="navstyle space mobile-menu"
                          onClick={(e) => this.ShipManagementNavigation(e)}
                        >
                          Ship Management
                        </Menu.Item>
                      </li>
                      <li>
                        <Menu.Item
                          key="M1"
                          className="navstyle space mobile-menu"
                          onClick={(e) => this.DeviceNavigation(e)}
                        >
                          Device Management
                        </Menu.Item>
                      </li>
                      <li>
                        <Menu.Item
                          key="M2"
                          className="navstyle space mobile-menu"
                          onClick={(e) => this.RankNavigation(e)}
                        >
                          Rank Management
                        </Menu.Item>
                      </li>
                      <li>
                        <Menu.Item
                          key="M2"
                          className="navstyle space mobile-menu"
                          onClick={(e) => this.CrewMemberNavigation(e)}
                        >
                          Crew Management
                        </Menu.Item>
                      </li>


                      <li>
                        <Menu.Item
                          key="M6"
                          className="navstyle space mobile-menu"
                          onClick={(e) => this.VisitorMemberNavigation(e)}
                        >
                          Visitor Management
                        </Menu.Item>
                      </li>
                      <li>
                        <Menu.Item
                          key="M9"
                          className="navstyle space mobile-menu"
                          onClick={(e) => this.DeviceCalibrationSearchNavigation(e)}
                        >
                          Device Calibration Due
                        </Menu.Item>
                      </li>
                      {/* <li>
                        <Menu.Item
                          key="M7"
                          className="navstyle space mobile-menu"
                          onClick={(e)=>this.CrewSearchNavigation(e)}
                        >
                          Crew Search
                        </Menu.Item>
                      </li> */}
                      <li>
                        <Menu.Item
                          key="M8"
                          className="navstyle space mobile-menu"
                          onClick={(e) => this.NewSearchNavigation(e)}
                        >
                          Reports
                        </Menu.Item>
                      </li>
                      <li>
                        <Menu.Item
                          key="M8"
                          className="navstyle space mobile-menu"
                          onClick={(e) => this.MonthlyReportNavigation(e)}
                        >
                          Monthly Reports
                        </Menu.Item>
                      </li>
                      <li>
                        <Menu.Item
                          key="M4"
                          className="navstyle space mobile-menu"
                          onClick={(e) => this.UserNavigation(e)}
                        >
                          MMPL User Management
                        </Menu.Item>
                      </li>
                      <li>
                        <Menu.Item
                          key="M10"
                          className="navstyle space mobile-menu"
                          onClick={(e) => this.SpecialAccessUserNavigation(e)}
                        >
                          Special Access User Management
                        </Menu.Item>
                      </li>

                      {/* <li>
                        <Menu.Item
                          key="M6"
                          className="navstyle space mobile-menu"
                          onClick={this.StaffManagementNavigation}
                        >
                          Ship Staff Management
                        </Menu.Item>
                      </li> */}
                    </ul>
                  </li>
                ) : null}
              </ul>
              {/* </div> */}
              {/* </nav> */}
              {/* <Menu.Item key="M1" className="navstyle space" onClick={this.MDNavigation}>MD Library</Menu.Item>
                            <Menu.Item key="M2" className="navstyle space" onClick={this.SMDNavigation}>SMD Library</Menu.Item>
                            <Menu.Item key="M3" className="navstyle space" onClick={this.ReportNavigation}>Reports</Menu.Item>
                            <Menu.Item key="M4" className="navstyle space" onClick={this.UserNavigation}>MMPL User Management</Menu.Item>
                            <Menu.Item key="M5" className="navstyle space" onClick={this.ShipViewNavigation}>Staff View</Menu.Item> */}
              {/* <Menu.Item key="M6" className="navstyle space" onClick={this.Certificates}>Certificates</Menu.Item> */}
              {/* <Menu.Item key="M7" className="navstyle space" onClick={this.MaintenanceRevision}>IHM Maintenance Revision</Menu.Item> */}
              {/* <Menu.Item key="M8" className="navstyle space" onClick={this.HazardessMaterial}>PO Hazardess</Menu.Item> */}
              <Menu.Item
                key="M9"
                className="navstyle space"
                style={{ color: "#ae1916", textDecoration: "underline" }}
                onClick={() => this.password()}
              >
                Change Password
              </Menu.Item>
              <Menu.Item
                key="M9"
                className="navstyle space"
                style={{ color: "#ae1916", textDecoration: "underline" }}
                onClick={() => this.logout()}
              >
                {userDetail.name} (Sign Out)
              </Menu.Item>
            </Menu>
          </div>
        ) : null}
      </div>
    );
  }

  logout() {
    this.authService.logout();
    // this.props.history.push("/logout");
  }

  UserAvatar(user) {
    return (
      // <i
      //   className="fa fa-user-circle fa-lg rounded-circle align-self-center mr-1"
      //   style={{ width: "32px", display: "content" }}
      // ></i>
      <span className="profile-icon-main"> <img className="profile-icon" src={profile} width={35} height={35}></img></span>
    );
  }

  CrewMemberNavigation = (e) => {
    this.props.dispatch({ type: "SubBannerTitle", data: "Crew Management" });
    this.setState({ show: false });
    this.props.dispatch({ type: "ShowSidePan", data: false });
    this.props.history.push("/Home/Management/CrewManagement");
    e.preventDefault();
  };
  StaffCrewMemberNavigation = (e) => {
    this.props.dispatch({ type: "SubBannerTitle", data: "Crew Management" });
    this.setState({ show: false });
    this.props.dispatch({ type: "ShowSidePan", data: false });
    this.props.history.push("/Home/CrewManagement");
    e.preventDefault();
  };

  RankNavigation = (e) => {
    this.props.dispatch({ type: "SubBannerTitle", data: "Rank Management" });
    this.setState({ show: false });
    this.props.dispatch({ type: "ShowSidePan", data: false });
    this.props.history.push("/Home/Management/Rank");
    e.preventDefault();
  };
  DeviceCalibrationSearchNavigation = (e) => {
    this.props.dispatch({ type: "SubBannerTitle", data: "Device Calibration Due" });
    this.setState({ show: false });
    this.props.dispatch({ type: "ShowSidePan", data: false });
    this.props.history.push("/Home/Management/DeviceCalibration");
    e.preventDefault();
  }

  VisitorMemberNavigation = (e) => {
    this.props.dispatch({ type: "SubBannerTitle", data: "Visitor Management" });
    this.setState({ show: false });
    this.props.dispatch({ type: "ShowSidePan", data: false });
    this.props.history.push("/Home/Management/VisitorManagement");
    e.preventDefault();
  };
  CrewSearchNavigation = (e) => {
    this.props.dispatch({ type: "Otherpages" });
    this.setState({ show: false });
    this.props.dispatch({ type: "SubBannerTitle", data: "Crew Search" });
    this.props.history.push("/Home/Management/CrewSearch");
    this.props.dispatch({ type: "EditPOView", data: false });
    e.preventDefault();
  };

  NewSearchNavigation = (e) => {
    this.props.dispatch({ type: "Otherpages" });
    this.setState({ show: false });
    this.props.dispatch({ type: "SubBannerTitle", data: "Reports" });
    this.props.history.push("/Home/Management/Report");
    this.props.dispatch({ type: "EditPOView", data: false });
    e.preventDefault();
  };
  MonthlyReportNavigation = (e) => {
    this.props.dispatch({ type: "Otherpages" });
    this.setState({ show: false });
    this.props.dispatch({ type: "SubBannerTitle", data: "Reports" });
    this.props.history.push("/Home/Management/MonthlyReport");
    this.props.dispatch({ type: "EditPOView", data: false });
    e.preventDefault();
  };

  MonthlyReportCommentsNavigation = (e) => {
    this.props.dispatch({ type: "Otherpages" });
    this.setState({ show: false });
    this.props.dispatch({
      type: "SubBannerTitle",
      data: "Monthly Compliance Reports",
    });
    this.props.history.push("/Home/Management/MonthlyReportComments");
    this.props.dispatch({ type: "EditPOView", data: false });
    if (e && e.preventDefault) {
      e.preventDefault();
    }
  };

  DeviceNavigation = (e) => {
    this.props.dispatch({ type: "MDDetail" });
    this.setState({ show: false });
    this.props.dispatch({ type: "ShowSidePan", data: false });
    this.props.dispatch({ type: "SubBannerTitle", data: "Device Management" });
    this.props.history.push("/Home/Management/Device");
    this.props.dispatch({ type: "EditPOView", data: false });
    e.preventDefault();
  };

  CrewVisitorSearchNavigation = (e) => {
    this.props.dispatch({ type: "Otherpages" });
    this.setState({ show: false });
    this.props.dispatch({ type: "SubBannerTitle", data: "Search" });
    this.props.history.push("/Home/Search");
    this.props.dispatch({ type: "EditPOView", data: false });
    e.preventDefault();
  };

  UserNavigation = (e) => {
    // this.props.dispatch({ type: 'User', data: false })
    this.props.dispatch({ type: "Otherpages" });
    this.setState({ show: false });
    this.props.dispatch({ type: "ShowSidePan", data: false });
    this.props.dispatch({
      type: "Title",
      data: "MMPL User Management",
    });
    this.props.history.push("/Home/Management/User");
    this.props.dispatch({ type: "EditPOView", data: false });
    e.preventDefault();
  };

  SpecialAccessUserNavigation = (e) => {
    this.props.dispatch({ type: "Otherpages" });
    this.setState({ show: false });
    this.props.dispatch({ type: "ShowSidePan", data: false });
    this.props.dispatch({
      type: "Title",
      data: "Special Access User Management",
    });
    this.props.history.push("/Home/Management/SpecialAccessUser");
    this.props.dispatch({ type: "EditPOView", data: false });
    e.preventDefault();
  };

  ShippingCompanyNavigation = (e) => {
    this.props.dispatch({ type: "ShowSidePan", data: false });
    this.setState({ show: false });
    this.props.dispatch({ type: "SubBannerTitle", data: "Client Dashboard" });
    this.props.history.push(`/Home/CompanyDashboard`);
    /*   e.preventDefault(); */
  };

  SettingsMemberNavigation = (e) => {
    this.props.dispatch({ type: "SubBannerTitle", data: "Settings" });
    this.setState({ show: false });
    this.props.dispatch({ type: "ShowSidePan", data: false });
    this.props.history.push("/Home/Settings");
    e.preventDefault();
  };

  SettingsMemberNavigationMobile = () => {
    this.props.dispatch({ type: "SubBannerTitle", data: "Settings" });
    this.setState({ show: false });
    this.props.dispatch({ type: "ShowSidePan", data: false });
    this.props.history.push("/Home/Settings");
  };

  ShipViewNavigation = (e) => {
    this.props.dispatch({ type: "ShowSidePan", data: false });
    this.setState({ show: false });
    this.props.dispatch({ type: "SubBannerTitle", data: "Ship Dashboard" });
    this.props.history.push(`/Home/StaffDashboard`);
    e.preventDefault();
  };

  ShipViewNavigationMobile = () => {
    this.props.dispatch({ type: "ShowSidePan", data: false });
    this.setState({ show: false });
    this.props.dispatch({ type: "SubBannerTitle", data: "Ship Dashboard" });
    this.props.history.push(`/Home/StaffDashboard`);
  };
  ShipManagementNavigation = (e) => {
    this.props.dispatch({ type: "ShowSidePan", data: false });
    this.setState({ show: false });
    this.props.dispatch({ type: "SubBannerTitle", data: "Ship Management" });
    this.props.history.push(`/Home/Management/Ship`);
    e.preventDefault();
  };

  StaffManagementNavigation = (e) => {
    this.props.dispatch({ type: "ShowSidePan", data: false });
    this.setState({ show: false });
    this.props.dispatch({
      type: "SubBannerTitle",
      data: "Ship Staff Management",
    });
    this.props.history.push(`/Home/Management/Staff`);
    e.preventDefault();
  };

  ClientManagementNavigation = (e) => {
    this.props.dispatch({ type: "ShowSidePan", data: false });
    this.setState({ show: false });
    this.props.dispatch({ type: "SubBannerTitle", data: "Client Management" });
    this.props.history.push(`/Home/Management/Client`);
    e.preventDefault();
  };

  MMPLDashboardNavigation = (e) => {
    this.props.dispatch({ type: "ShowSidePan", data: false });
    this.setState({ show: false });
    this.props.dispatch({ type: "SubBannerTitle", data: "Dashboard" });
    this.props.history.push("/Home/MMPLDashboard");
    e.preventDefault();
  };
}

function mapStateToProps(state) {
  return {
    userDisplayName: state.SidePanReducer.userDisplayName,
    userDetail: state.SidePanReducer.userDetail,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}
export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(MMTopPane)
);
